// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class TaskByLevelWithNotes {
  levelID: string;
  levelDescription: string;
  taskID: string;
  taskDescription: string;
  pmHours: number;
  engHours: number;
  grapHours: number;
  progHours: number;
  specHours: number;
  ddsHours: number;
  mechHours: number;
  elecHours: number;
  servicingOffice: string;
  notes: string;
  typicalOfCount: string;
}
